@if (!fullPageMode) {
  <button #recallTrigger (onMenuOpen)="onMenuOpen()" [disabled]="!hasRecalls"
          [matMenuTriggerFor]="recallMenu"
          [ngClass]="recallTriggerBtn && recallTriggerBtn.menuOpen || !hasRecalls ? '' : 'pulse'"
          mat-icon-button>
    <mat-icon [ngClass]="hasRecalls ? 'recall-active-icon' : 'recall-inactive-icon'"
              fontIcon="fa-rotate-left" fontSet="fa-solid" class="recall-icon">
    </mat-icon>
    @if (recallCount > 0 && recallCount < 10) {
      <span class="badge-count">{{ recallCount }}</span>
    }
    @if (recallCount >= 10) {
      <span class="badge-count-large">{{ recallCount }}</span>
    }
  </button>
  <mat-menu #recallMenu="matMenu" class="padded-menu" xPosition="before">
    @if (activeRecalls.length === 0) {
      <p class="no-recalls-text">No active recalls</p>
    }
    @for (recall of activeRecalls; track recall.id) {
      <div (click)="openTicketDialog(recall)" class="recall-menu-widget">
        <div>
          <div class="recall-header">
            <i class="fa-solid {{ getStatusIcon(recall.status) }}"></i>
            <strong>Ticket {{ recall.ticket?.id }}</strong>
            <span class="spacer"></span>
            @if (recall.status !== 'COMPLETED' && recall.status !== 'CANCELLED') {
              <button (click)="cancelRecall(recall, $event)" class="cancel-btn"
                      title="Cancel recall">
                <i class="fa-solid fa-xmark"></i>
              </button>
            }
          </div>
          <div class="recall-status">
            {{ getStatusLabel(recall.status) }}
          </div>
          <div class="recall-meta">
            Requested {{ recall.requestedTime | amTimeAgo }}
            @if (recall.requestedBy) {
              by {{ recall.requestedBy }}
            }
          </div>
        </div>
      </div>
    }
  </mat-menu>
}
